import React, { useEffect } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";

import {
  InputField,
  CheckBox,
  FormSectionTitle,
  Separator,
  SearchableSelect,
  Select,
} from "../../../../components/form";

import ModerationForm from "../../../../components/form/ModerationForm";

import { customerByIdSelector } from '../../../../modules/customersModearion/customers/Selectors'

import { getSinglePendingCustomerAction, moderateCreateSinglePendingCustomerAction, updatePendingCustomerAction, getPendingCustomersAction } from "../../../../modules/customersModearion/customers/Actions";
import {
  customersIsLoadingSelector

} from "../../../../modules/customers/Selectors";

import { pendingCustomersIsLoadingSelector } from "../../../../modules/customersModearion/customers/Selectors"
import getLangData from "../../../../utils/getLangData";

const options = [
  { value: ["0"], label: "Individual" },
  { value: ["1"], label: "Company" },
];

const CustomersForm = (props) => {
  const {
    getCustomer,
    moderationId,
    customerId,
    customer,
    updatePendingCustomer,
    customersIsLoading,
    pendingCustomersIsLoading,
    moderateCreatePendingCustomer,
    getCustomers
  } = props;

  useEffect(() => {
    // getCustomer(customerId);
    getCustomers()
  }, [getCustomer, customerId]);
  const lang = getLangData().fields
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...customer }}
      onSubmit={(values) => {
        moderateCreatePendingCustomer({

          id: customerId,
        }, values.moderationType);
      }}
    >
      {({ handleSubmit }) => (
        <ModerationForm
          heading={customer ? lang.update_customer : lang.create_customer}
          handleSubmit={handleSubmit}
          isLoading={customersIsLoading || pendingCustomersIsLoading}
        >
          <FormSectionTitle>{lang.basic_information} :</FormSectionTitle>
          {/* <SearchableSelect
            name='userID'
            label='User'
            optionLabel={(option) => `${option.firstName} ${option.lastName}`}
          /> */}
          <InputField label={lang.busience_name} name='businessName' />
          <Select
            options={options}
            name='customerType'
            label={lang.customer_type}
            inArray={true}
          />
          <Separator />
          <FormSectionTitle>{lang.year} :</FormSectionTitle>
          <InputField name='yearEstablished' label={lang.year_established} />
          <CheckBox
            name='regCompany'
            label={lang.registered_company}
            subLabel='I have Registered Company.'
          />{" "}
          <InputField label={lang.company_size} name='companySize' />
          <Separator />


        </ModerationForm>
      )}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const customerId = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    moderationId,
    customerId,
    customer: customerByIdSelector(state, customerId),
    customersIsLoading: customersIsLoadingSelector(state),

    pendingCustomersIsLoading: pendingCustomersIsLoadingSelector(state)
  };
};

const mapDispatchToProps = {
  getCustomer: getSinglePendingCustomerAction,
  moderateCreatePendingCustomer: moderateCreateSinglePendingCustomerAction,
  getCustomers: getPendingCustomersAction
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersForm);
